"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _useToggle3 = _interopRequireDefault(require("react-use/lib/useToggle"));
var _Dropdown = require("../Dropdown");
var _excluded = ["isHoverable"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var WithContainer = function WithContainer(_ref) {
  var isHoverable = _ref.isHoverable,
    originalProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var hasTogglerWidth = originalProps.hasTogglerWidth;
  var _useToggle = (0, _useToggle3["default"])(false),
    _useToggle2 = (0, _slicedToArray2["default"])(_useToggle, 2),
    isMenuVisible = _useToggle2[0],
    setIsMenuVisible = _useToggle2[1];
  var dropdownTogglerRef = (0, _react.useRef)(null);
  var dropdownMenuRef = (0, _react.useRef)(null);
  var menuPositionInitialValue = (0, _react.useMemo)(function () {
    return {
      left: null,
      arrowLeft: null,
      width: null
    };
  }, []);
  var _useState = (0, _react.useState)(menuPositionInitialValue),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    menuPositionConfig = _useState2[0],
    setMenuPositionConfig = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    hasPositionCalculated = _useState4[0],
    setHasPositionCalculated = _useState4[1];
  var handleMouseEnter = (0, _react.useCallback)(function () {
    if (isHoverable) {
      setIsMenuVisible(true);
    }
  }, [isHoverable, setIsMenuVisible]);
  var handleMouseLeave = (0, _react.useCallback)(function () {
    if (isHoverable) {
      setIsMenuVisible(false);
      setMenuPositionConfig(menuPositionInitialValue);
      setHasPositionCalculated(false);
    }
  }, [isHoverable, setIsMenuVisible, menuPositionInitialValue]);
  var handleOnClick = (0, _react.useCallback)(function () {
    setIsMenuVisible();
    if (hasPositionCalculated) {
      setHasPositionCalculated(false);
      setMenuPositionConfig(menuPositionInitialValue);
    }
  }, [setIsMenuVisible, hasPositionCalculated, menuPositionInitialValue]);
  (0, _react.useEffect)(function () {
    if (isMenuVisible && dropdownTogglerRef.current && dropdownMenuRef.current) {
      var _dropdownTogglerRef$c = dropdownTogglerRef.current.getBoundingClientRect(),
        togglerLeft = _dropdownTogglerRef$c.left,
        togglerRight = _dropdownTogglerRef$c.right,
        togglerWidth = _dropdownTogglerRef$c.width;
      var _dropdownMenuRef$curr = dropdownMenuRef.current.getBoundingClientRect(),
        menuWidth = _dropdownMenuRef$curr.width;
      var containersWidthDifference = menuWidth - togglerWidth;
      var offset = containersWidthDifference / 2;
      var left = null;
      var arrowLeft = null;
      var width = null;
      switch (true) {
        case hasTogglerWidth:
          break;
        case togglerWidth > menuWidth:
          left = (togglerWidth - menuWidth) / 2;
          break;
        case togglerRight + offset > window.innerWidth:
          {
            left = -containersWidthDifference;
            arrowLeft = containersWidthDifference;
            break;
          }
        case togglerLeft - offset > 0:
          {
            left = -offset;
            break;
          }
        default:
          {
            arrowLeft = -containersWidthDifference;
            break;
          }
      }
      if (hasTogglerWidth) {
        width = togglerWidth;
      }
      setMenuPositionConfig({
        left: left,
        arrowLeft: arrowLeft,
        width: width
      });
      setHasPositionCalculated(true);
    }
  }, [hasTogglerWidth, isMenuVisible, setHasPositionCalculated]);
  var injectedProps = {
    isMenuVisible: isMenuVisible,
    onClick: handleOnClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    dropdownTogglerRef: dropdownTogglerRef,
    dropdownMenuRef: dropdownMenuRef,
    menuPositionConfig: menuPositionConfig,
    hasPositionCalculated: hasPositionCalculated
  };
  return /*#__PURE__*/_react["default"].createElement(_Dropdown.Dropdown, (0, _extends2["default"])({}, originalProps, injectedProps));
};
exports.WithContainer = WithContainer;
WithContainer.Toggler = _Dropdown.Dropdown.Toggler;
WithContainer.List = _Dropdown.Dropdown.List;